import { SANDBOX_BANNER_ID } from '../../external-contrib/sandbox-banner/constants/constants';
import { getSandboxBannerHeight } from '../selectors';
import { getRootNavSandboxBannerHeight } from './getRootNavSandboxBannerHeight';
import { updateRootnavComponentDimension } from './updateRootnavComponentDimension';
export const updateSandboxBannerComponentDimensionMaybe = store => {
  const sandboxBannerRendered = !!document.getElementById(SANDBOX_BANNER_ID);
  const storedHeight = getSandboxBannerHeight(store.getState());
  if (sandboxBannerRendered || storedHeight !== 0) {
    const currentHeight = getRootNavSandboxBannerHeight();
    if (currentHeight !== storedHeight) {
      updateRootnavComponentDimension('SandboxBanner', {
        height: currentHeight
      }, store.dispatch);
    }
  }
};